/**
 * Turns a Laravel 422 error bag into one human sentence for a toast.
 *
 * The lead info form posts every field it was rendered with — including ones it
 * has no control for — so a validation failure can name an attribute that has
 * no input, and therefore no `isInvalid()` slot, anywhere on the page. When
 * that happened the 422 branch rendered nothing at all: no inline message, no
 * toast, and `scrollToClass('has-error')` found no element to scroll to. The
 * agent clicked "Update Lead Info", the spinner blinked, and the save silently
 * did nothing.
 *
 * Inline messages remain the primary display for fields that have one; this is
 * the backstop that guarantees *something* is always shown.
 *
 * @param {?object} errors  Laravel's `errors` bag: { field: [message, ...] }
 * @param {number}  max     how many messages to spell out before summarising
 * @returns {string}
 */
export function summarizeValidationErrors(errors, max = 3) {
    const messages = Object.values(errors ?? {})
        .flat()
        .filter((message) => typeof message === 'string' && message.trim() !== '');

    if (messages.length === 0) {
        return 'The lead could not be saved. Please check the highlighted fields.';
    }

    if (messages.length <= max) {
        return messages.join(' ');
    }

    return `${messages.slice(0, max).join(' ')} (+${messages.length - max} more)`;
}
